import api from './Axios';

/**
 * Investments API
 * Base: /api/investments
 */

export const createInvestment = (data) =>
  api.post('/investments', data);

export const getInvestments = () =>
  api.get('/investments');

export const getInvestmentById = (investmentId) =>
  api.get(`/investments/${investmentId}`);

export const updateInvestment = (investmentId, data) =>
  api.put(`/investments/${investmentId}`, data);

export const approveInvestment = (investmentId) =>
  api.post(`/investments/${investmentId}/approve`);